<template>
	<div class="progress-container">
		<div class="wrapper-progress">
			<progress-bar :value="progressComputed" :quantity="quantity"/>
			<span
				:class="[
					'progress-text',
					{ complete: 'complete' },
				]"
				:style="`color: ${$appColors.success}`"
			>{{progressText}}</span>
		</div>
		<v-icon
			class="complete-icon"
			:disabled="disabled"
			color="success"
			size="20"
		>
			check_circle
		</v-icon>
	</div>
</template>
<script>
function progressText() {
	return this.progressComputed === 100 ? 'Completo' : this.calcProgress;
}

function calcProgress() {
	return this.quantity ? `${this.value}/${this.quantity}` : `${this.value}%`;
}

function complete() {
	return this.progressComputed === 100;
}

function disabled() {
	return this.progressComputed !== 100;
}

function progressComputed() {
	return this.quantity ? (this.value / this.quantity) * 100 : this.value;
}

export default {
	name: 'progress-bar-component',
	components: {
		progressBar: () => import('@/components/shared/progress-bar'),
	},
	computed: {
		calcProgress,
		complete,
		disabled,
		progressComputed,
		progressText,
	},
	props: {
		quantity: {
			default: 0,
			type: Number,
		},
		value: null,
	},
};
</script>
<style lang="scss" scoped>
	.progress-container {
		align-items: center;
		display: flex;
		justify-content: space-between;
	}

	.wrapper-progress {
		@include flex-right;
		width: 270px;
	}

	.progress-text {
		font-size: size(small);
	}

	.complete {
		color: color(success);
	}

	.complete-icon {
		margin: 0 0 20px 5px;
	}
</style>




// WEBPACK FOOTER //
// src/components/polls/progress-bar-component.vue